/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf15.png';

const SharePriceStep3 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="SHARE PRICE"
    hideAlert={true}
    subTitle="Excess Share Issuance"
    paragraph1={(
      <Fragment>
        Issuing too many shares can also reduce a company’s share price if the new shares are
        offered at a price below the share’s current price. Google, for example, felt their
        share price was too high and therefore intentionally reduced their share price by
        issuing excessive # of new shares at an implied price of $0 (i.e. via stock
        split). <a href="https://www.cnbc.com/2022/02/02/what-is-a-stock-split-what-alphabets-20-for-1-split-means-for-you.html" rel="noreferrer" target="_blank">Learn More</a>
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        In the simulation, all new shares are issued at current prices and therefore
        issuing new shares will technically not have an adverse impact on your company's value.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default SharePriceStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/share-price/step3.js